export default __webpack_public_path__ + "static/icon-pt1-healing-6-key-f29f39ed12ac82943f17de6a23844963.png";